import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import COLOR from 'utils/constants/color';
import { Col, Row } from 'antd';
import LoginForm from 'features/forms/Login';
import RegistrationForm from 'features/forms/Registration';
import { useNavigate } from "react-router-dom";
import { LoginLogo, StarRating, personGreen1 } from "utils/assets/images";
import SentryWrap from 'components/Sentry';
import AlertModal from 'components/AlertModal';
const Container = styled.div`
    background-color: rgba(255, 255, 255, 1);
    border-radius: 9px;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    height: auto;
    max-width: 315px;
    padding: 22px 20px 22px;
    width: 100%;
    margin-bottom:15px;
`;
const Link = styled.span`
    color: ${COLOR.white};
    font-size: 12px;
    margin-bottom: 4px;
    cursor: pointer; 
    font-weight:900;
    text-shadow: 2px 2px 4px rgb(0 0 0);
    &:last-child {
        margin-bottom: 0px;
    }

    @media (min-width: 600px) {
        margin-bottom: 0px;
    }
    &:hover {
        // border-bottom: 2px solid ${COLOR.white};
        text-decoration: underline;
        color: white;
    }

`;
const Wrapper = styled.div`
    align-items: center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

const slideFadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

const slideFadeOut = keyframes`
    from {
        opacity: 1;
        transform: translateX(0);
    }
    to {
        opacity: 0;
        transform: translateX(-20px);
    }
`;

const FormTransition = styled.div`
    animation: ${props => props.$isEntering ? slideFadeIn : slideFadeOut} 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    will-change: opacity, transform;
`;

const LoginContainer = () => {
    const [registrationFlag, setRegistrationFlag] = useState(false);
  	const navigate = useNavigate();

    return (
    <SentryWrap>
        <div className="logCstmMainUpr">
            <Row className="logCstmMain">
                <Col xs={24} md={24} lg={7} className="logCstmLeft"  style={{display:"flex",flexDirection:"row", justifyContent:"space-between"}}>
                    <div><img  onClick={()=>navigate("/")} src={LoginLogo} style={{cursor:"pointer"}} title="One Way Education" alt="One Way Education" /></div>
                </Col>
                <Col xs={24} md={24} lg={10} className="logCstmMid">
                    <Wrapper>
                        <AlertModal />
                        <Container>
                            <FormTransition key={registrationFlag ? 'registration' : 'login'} $isEntering={true}>
                                {registrationFlag ? (
                                    <RegistrationForm toggleRegistration={() => setRegistrationFlag(false)} />
                                ) : (
                                    <LoginForm toggleTransition={() => {}} toggleRegistration={() => setRegistrationFlag(true)} />
                                )}
                            </FormTransition>
                        </Container>
                        <Link onClick={() => navigate("/terms-conditions")}>Terms and Conditions</Link>
                        <Link onClick={() => navigate("/privacy-policy")}>Data Privacy Policy</Link>
                        <Link onClick={() => navigate("/student-information-privacy-notice")}>Student Information Privacy Notice</Link>
                    </Wrapper>
                </Col>
                <Col xs={24} md={24} lg={7} className="logCstmRght">
                    <div><img src={StarRating} title="" alt="" /></div>
                </Col>
                <div className="logBtmImg"><img src={personGreen1} title="" alt="" /></div>
            </Row>
        </div>
    </SentryWrap>
    );
};

export default LoginContainer;
